export default __webpack_public_path__ + "static/media/ilustracao-caderneta-mobile.87939bf1.svg";